module.exports = __webpack_public_path__ + "static/media/js.87711407.svg";